import {Component, OnInit, ViewChild} from '@angular/core';
import {Subject, Subscription} from "rxjs";
import {DataTableDirective} from "angular-datatables";
import {UserDataStoreService} from "../services/user-data-store.service";
import {AuthenticationService} from "../services/authentication.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { Router } from '@angular/router';
import {TerminalConfigService} from "../services/terminal-config.service";
import {TerminalConfigViewModel} from "../models/terminal-config-view-model";
import { ToastrService } from 'ngx-toastr';
import { PermissionEnum } from '../services/guards/permissions';
import {ConfirmationDialogComponent} from "../partials/confirmation-dialog/confirmation-dialog.component";
import { NgxUiLoaderService } from 'ngx-ui-loader';


@Component({
  selector: 'app-terminal-management-config-audit',
  templateUrl: './terminal-management-config-audit.component.html',
  styleUrls: ['./terminal-management-config-audit.component.scss']
})
export class TerminalManagementConfigAuditComponent implements OnInit {

  public dtOptions: DataTables.Settings = {};
  public terminalConfigs: TerminalConfigViewModel[] = [];
  public dtTrigger: Subject<boolean> = new Subject();

  public canView: boolean = false;
  public canEdit: boolean = false;
  public canAdd: boolean = false;
  public canDelete: boolean = false;
  public AddButton: string;
  public EditButton: string;
  public DeleteButton: string;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;


  constructor(
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _terminalConfigService: TerminalConfigService,
    private _toastService: ToastrService,
    private _ngxUiLoaderService: NgxUiLoaderService) {

    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalAudit], []);
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }    
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
  }

  public async ngAfterViewInit(): Promise<void> {
    await this.init();
  }

  private async init(): Promise<void> {
    this._ngxUiLoaderService.start();
    this.terminalConfigs = await this._terminalConfigService.GetAllConfigs();
    this.dtTrigger.next();

    this._ngxUiLoaderService.stop();
  }

  private resetDatatable(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public async viewTerminalConfig(terminal: TerminalConfigViewModel): Promise<void> {
    this._router.navigate(['management', 'audit-terminal-config', terminal.id]);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

}
